import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon } from 'lucide-react';
export function OfferSection() {
  return <section id="oferta" className="bg-[#F5EDE0] py-16 md:py-24 px-4 sm:px-6 lg:px-8" data-id="element-133">
      <div className="max-w-4xl mx-auto text-center" data-id="element-134">
        <div className="bg-white rounded-3xl p-8 md:p-14 shadow-2xl border-2 border-[#B8A068] relative overflow-hidden" data-id="element-135">
          {/* Decorative background element */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#FDF8F0] rounded-full mix-blend-multiply filter blur-3xl opacity-50 -translate-y-1/2 translate-x-1/2" data-id="element-136"></div>

          <div className="relative z-10" data-id="element-137">
            <h2 className="font-playfair text-3xl md:text-4xl font-bold text-[#3D2E1F] mb-6" data-id="element-138">
              Empieza tu transformación hoy
            </h2>

            <p className="text-[#3D2E1F] mb-8 max-w-2xl mx-auto" data-id="element-139">
              Recupera tus mañanas por menos de lo que cuesta un frasco de
              analgésicos que solo duran un mes. Invierte una sola vez en el
              conocimiento que te servirá para el resto de tu vida.
            </p>

            <div className="mb-10" data-id="element-140">
              <span className="inline-block bg-red-600 text-white font-bold text-sm md:text-base uppercase tracking-widest px-4 py-1.5 rounded-full mb-4" data-id="element-141">
                68% OFF
              </span>
              <div className="flex items-center justify-center gap-4 mb-1" data-id="element-142">
                <span className="text-[#3D2E1F] opacity-50 line-through text-2xl md:text-3xl font-playfair" data-id="element-143">
                  $19.99 USD
                </span>
              </div>
              <span className="font-playfair text-6xl md:text-7xl font-bold text-[#B8A068]" data-id="element-144">
                $6.39 USD
              </span>
            </div>

            <div className="flex flex-col items-center justify-center gap-6" data-id="element-145">
              <CTAButton href="https://www.fluiresvivir.com/cart/43661204652097:1" target="_blank" rel="noopener noreferrer" aria-label="Comprar el diario Despierta Sin Dolor por 6 dólares 39 centavos" data-id="element-146">
                ¡QUIERO DESPERTAR SIN DOLOR AHORA!
              </CTAButton>

              <div className="flex items-center gap-2 text-[#3D2E1F] opacity-80 text-sm md:text-base mt-4" data-id="element-147">
                <ShieldCheckIcon className="w-5 h-5 text-green-600" aria-hidden="true" data-id="element-148" />
                <span data-id="element-149">
                  Acceso inmediato tras el pago. Compra 100% segura y privada.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}